export type PdfBookmarkItem = {
  title: string;
  dest: any;
  level: number;
};

export const flattenPdfOutline = (
  items: any[] | null | undefined,
  level = 0
): PdfBookmarkItem[] => {
  if (!items?.length) return [];
  const flattened: PdfBookmarkItem[] = [];
  items.forEach((item) => {
    flattened.push({
      title: item.title || "Untitled",
      dest: item.dest,
      level
    });
    if (item.items?.length) {
      flattened.push(...flattenPdfOutline(item.items, level + 1));
    }
  });
  return flattened;
};

export const resolveBookmarkPage = async (
  pdfDoc: any,
  dest: any
): Promise<number | null> => {
  if (!dest) return null;
  let destination = dest;
  if (typeof destination === "string") {
    destination = await pdfDoc.getDestination(destination);
  }
  if (!destination?.length) return null;
  const pageIndex = await pdfDoc.getPageIndex(destination[0]);
  return pageIndex + 1;
};

export const loadPdfBookmarks = async (pdfDoc: any): Promise<PdfBookmarkItem[]> => {
  try {
    const outline = await pdfDoc.getOutline();
    return flattenPdfOutline(outline);
  } catch {
    return [];
  }
};
